
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';

const RAW_EVENTS = [
  { month: 'JAN', day: '19–21', name: 'ICE Barcelona', city: 'Barcelona, Spain', start: '2026-01-19', end: '2026-01-21' },
  { month: 'APR', day: '6–9', name: 'SiGMA Americas', city: 'São Paulo, Brazil', start: '2026-04-06', end: '2026-04-09' },
  { month: 'JUN', day: '1–3', name: 'SiGMA Asia', city: 'Manila, Philippines', start: '2026-06-01', end: '2026-06-03' },
  { month: 'JUN', day: '9–11', name: 'SBC Summit Americas', city: 'Fort Lauderdale, USA', start: '2026-06-09', end: '2026-06-11' },
  { month: 'JUL', day: '14–17', name: 'iGB L!VE', city: 'Amsterdam, Netherlands', start: '2026-07-14', end: '2026-07-17' },
  { month: 'SEP', day: '1–3', name: 'SiGMA North America', city: 'Mexico City, Mexico', start: '2026-09-01', end: '2026-09-03' },
  { month: 'SEP', day: '28 – OCT 1', name: 'G2E Las Vegas', city: 'Las Vegas, USA', start: '2026-09-28', end: '2026-10-01' },
  { month: 'SEP', day: '29 – OCT 1', name: 'SBC Summit', city: 'Lisbon, Portugal', start: '2026-09-29', end: '2026-10-01' },
  { month: 'NOV', day: '2–5', name: 'SiGMA World', city: 'Rome, Italy', start: '2026-11-02', end: '2026-11-05' },
];

@Options({
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    },
    events() {
      const now = new Date();
      const withStatus = RAW_EVENTS.map((event) => {
        const start = new Date(event.start);
        const end = new Date(event.end.length === 10 ? `${event.end}T23:59:59` : event.end);
        let status: 'done' | 'live' | 'upcoming' = 'upcoming';
        if (now > end) status = 'done';
        else if (now >= start && now <= end) status = 'live';
        return { ...event, status };
      });

      const nextIndex = withStatus.findIndex((event) => event.status !== 'done');
      if (nextIndex !== -1 && withStatus[nextIndex].status === 'upcoming') {
        withStatus[nextIndex] = { ...withStatus[nextIndex], status: 'next' as any };
      }
      return withStatus;
    }
  },
  methods: {
    statusLabel(status: string) {
      const jsonData = (this as any).jsonData;
      switch (status) {
        case 'done': return jsonData.eventsStatusDone;
        case 'live': return jsonData.eventsStatusLive;
        case 'next': return jsonData.eventsStatusNext;
        default: return jsonData.eventsStatusUpcoming;
      }
    }
  }
})
export default class EventsCalendar extends Vue {}
